import endpoints from '@app/src/api/endpoints'
import { FetchKey, useFetchResource } from '@app/src/api/fetchHooks'
import { useLDClient } from 'launchdarkly-react-client-sdk'
import { ONE_HOUR_MS, ONE_MINUTE_MS } from '@app/src/wf-constants'

interface useFeatureFlagsByAccessorProps {
  featureToggleName: string
  enabled?: boolean
  priorityValue?: boolean
}

const useFeatureFlagsByAccessor = ({ featureToggleName, enabled, priorityValue }: useFeatureFlagsByAccessorProps) => {
  const ldClient = useLDClient()
  const hasOwnAccess: boolean = ldClient?.variation(featureToggleName, false) ?? false
  const accessorFlagCheckEnabled = enabled && (priorityValue !== undefined || !hasOwnAccess)

  const { data: anyAccessorHasFeature, isLoading } = useFetchResource<boolean>({
    key: FetchKey.AccessorFeature,
    endpoint: endpoints.anyAccessorHasFeature(featureToggleName),
    options: {
      enabled: accessorFlagCheckEnabled,
      gcTime: ONE_HOUR_MS,
      staleTime: ONE_MINUTE_MS,
    },
  })

  let orgOrAccessorHasFeature =
    accessorFlagCheckEnabled && isLoading ? false : hasOwnAccess || (anyAccessorHasFeature ?? false)

  if (priorityValue !== undefined) {
    if (priorityValue === anyAccessorHasFeature) {
      orgOrAccessorHasFeature = anyAccessorHasFeature
    } else if (priorityValue === hasOwnAccess) {
      orgOrAccessorHasFeature = hasOwnAccess
    }
  }

  return { orgOrAccessorHasFeature, isLoading }
}

export default useFeatureFlagsByAccessor
